import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.is-extensible";
export { default as Calendar } from "./calendar";

if (typeof Calendar !== 'undefined' && Calendar && Calendar === Object(Calendar) && Object.isExtensible(Calendar) && !Calendar.hasOwnProperty('__filemeta')) {
  Object.defineProperty(Calendar, '__filemeta', {
    configurable: true,
    value: {
      name: "Calendar",
      filename: "node_modules/react-native-calendars/src/index.js"
    }
  });
}

export { default as CalendarList } from "./calendar-list";

if (typeof CalendarList !== 'undefined' && CalendarList && CalendarList === Object(CalendarList) && Object.isExtensible(CalendarList) && !CalendarList.hasOwnProperty('__filemeta')) {
  Object.defineProperty(CalendarList, '__filemeta', {
    configurable: true,
    value: {
      name: "CalendarList",
      filename: "node_modules/react-native-calendars/src/index.js"
    }
  });
}

export { default as Agenda } from "./agenda";

if (typeof Agenda !== 'undefined' && Agenda && Agenda === Object(Agenda) && Object.isExtensible(Agenda) && !Agenda.hasOwnProperty('__filemeta')) {
  Object.defineProperty(Agenda, '__filemeta', {
    configurable: true,
    value: {
      name: "Agenda",
      filename: "node_modules/react-native-calendars/src/index.js"
    }
  });
}

export { default as ExpandableCalendar } from "./expandableCalendar";

if (typeof ExpandableCalendar !== 'undefined' && ExpandableCalendar && ExpandableCalendar === Object(ExpandableCalendar) && Object.isExtensible(ExpandableCalendar) && !ExpandableCalendar.hasOwnProperty('__filemeta')) {
  Object.defineProperty(ExpandableCalendar, '__filemeta', {
    configurable: true,
    value: {
      name: "ExpandableCalendar",
      filename: "node_modules/react-native-calendars/src/index.js"
    }
  });
}

export { default as AgendaList } from "./expandableCalendar/agendaList";

if (typeof AgendaList !== 'undefined' && AgendaList && AgendaList === Object(AgendaList) && Object.isExtensible(AgendaList) && !AgendaList.hasOwnProperty('__filemeta')) {
  Object.defineProperty(AgendaList, '__filemeta', {
    configurable: true,
    value: {
      name: "AgendaList",
      filename: "node_modules/react-native-calendars/src/index.js"
    }
  });
}

export { default as Timeline } from "./timeline/Timeline";

if (typeof Timeline !== 'undefined' && Timeline && Timeline === Object(Timeline) && Object.isExtensible(Timeline) && !Timeline.hasOwnProperty('__filemeta')) {
  Object.defineProperty(Timeline, '__filemeta', {
    configurable: true,
    value: {
      name: "Timeline",
      filename: "node_modules/react-native-calendars/src/index.js"
    }
  });
}

export { default as CalendarProvider } from "./expandableCalendar/calendarProvider";

if (typeof CalendarProvider !== 'undefined' && CalendarProvider && CalendarProvider === Object(CalendarProvider) && Object.isExtensible(CalendarProvider) && !CalendarProvider.hasOwnProperty('__filemeta')) {
  Object.defineProperty(CalendarProvider, '__filemeta', {
    configurable: true,
    value: {
      name: "CalendarProvider",
      filename: "node_modules/react-native-calendars/src/index.js"
    }
  });
}

export { default as asCalendarConsumer } from "./expandableCalendar/asCalendarConsumer";

if (typeof asCalendarConsumer !== 'undefined' && asCalendarConsumer && asCalendarConsumer === Object(asCalendarConsumer) && Object.isExtensible(asCalendarConsumer) && !asCalendarConsumer.hasOwnProperty('__filemeta')) {
  Object.defineProperty(asCalendarConsumer, '__filemeta', {
    configurable: true,
    value: {
      name: "asCalendarConsumer",
      filename: "node_modules/react-native-calendars/src/index.js"
    }
  });
}

export { default as WeekCalendar } from "./expandableCalendar/weekCalendar";

if (typeof WeekCalendar !== 'undefined' && WeekCalendar && WeekCalendar === Object(WeekCalendar) && Object.isExtensible(WeekCalendar) && !WeekCalendar.hasOwnProperty('__filemeta')) {
  Object.defineProperty(WeekCalendar, '__filemeta', {
    configurable: true,
    value: {
      name: "WeekCalendar",
      filename: "node_modules/react-native-calendars/src/index.js"
    }
  });
}

export { default as LocaleConfig } from 'xdate';

if (typeof LocaleConfig !== 'undefined' && LocaleConfig && LocaleConfig === Object(LocaleConfig) && Object.isExtensible(LocaleConfig) && !LocaleConfig.hasOwnProperty('__filemeta')) {
  Object.defineProperty(LocaleConfig, '__filemeta', {
    configurable: true,
    value: {
      name: "LocaleConfig",
      filename: "node_modules/react-native-calendars/src/index.js"
    }
  });
}